TPS.Register = {
    member: '#divMember',
    vpid: '#divVpid',
    ssa: '#divSsa',
    partnerCodeSelector: '#partnerCode',
    partnerCompanySelector: '#partnerCompany',
    emailAddressSelector: '#emailAddress',
    confirmEmailAddressSelector: '#confirmEmailAddress',
    formParentSelector: null,
    errorBlockSelector: '#error-callout',
    companyData: null,
    partnerCode: null,
    cultureID: 'en-US',
    continueSectionSelector: '.continue-section',
    btnEditSectionSelector: '.btn-edit-section',
    
    init: function (formWrapper) {
        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Company');
        TPS.Register.partnerCode = TPS.Util.getUrlParameter("partner");
        TPS.Register.cultureID = document.getElementById('lng').value;
        TPS.Register.formParentSelector = formWrapper;
        jQuery('#RegisterCancel, #RegisterSubmit').hide();
        
        // doe the form have a wrapper?
        if (TPS.Register.formParentSelector) {
            
            TPS.Forms.setupClientValidation(TPS.Register.formParentSelector); // .registration-form                    

            // if we have a partner code in the URL
            // populate the input and check it on the BE            
            if (TPS.Register.partnerCode) {
                jQuery(TPS.Register.partnerCodeSelector).val(TPS.Register.partnerCode);
                TPS.Register.sendPartnerCode();
            } else {
                TPS.Register.displayRegisterForm(false);
            }
            
            // set event listeners to keyboard
            // events on partnercode field
            TPS.Register.submitForm();
        }
    },

    TrimEmailWhiteSpaces: function () {
        var _emailInput = jQuery(TPS.Register.emailAddressSelector);
        var _confirmEmailInput = jQuery(TPS.Register.confirmEmailAddressSelector);
        _emailInput.add(_confirmEmailInput).on('blur input', function (e) {
            _emailInput.val(_emailInput.val().trim());
            _confirmEmailInput.val(_confirmEmailInput.val().trim());
        });
    },

    CheckEmailDomain: function () {
        jQuery(document).on('change', TPS.Register.emailAddressSelector, function () {
            var _target = jQuery(this);

            // reset the state of the field
            _target.removeClass('email-not-recognized');
            _target.next('.field-message').remove();

            // is the email input in a valid state?
            if (_target.valid()) {
                // disable the input while we 
                // check the email domain
                _target.prop('readonly', true);

                CMSApp.AV.API.Company.ValidateEmailDomain(
                    TPS.Register.partnerCode,
                    _target.val(),
                    TPS.Register.cultureID,

                    function (data) {
                        // if we have the valiation object
                        // and if there are errors
                        if (data.Object && data.Object.ValidationResult === false) {
                            // add the class
                            _target.addClass('email-not-recognized')

                            // message content
                            var _messageContent = TPS.Register.createEmailDomainMessage();

                            if (TPS.Register.companyData.CompanyRegistrationTypeID === 2) {
                                _messageContent = TPS.Register.createIDmeMessage();
                            }

                            // and append the message after the field
                            _target.after(jQuery('<div>').addClass('field-message').html(_messageContent)).focus();

                            if (TPS.Register.companyData.CompanyRegistrationTypeID === 2) {
                                var _idmebutton = document.getElementById('idme-wallet-button');
                                if (_idmebutton) {
                                    window.BindIDme(); // manually init ID.me because this section was hidden
                                }
                            }
                        }

                        // re-enable the field
                        _target.prop('readonly', false);
                    },
                    function (data) {
                        // re-enable the field
                        _target.prop('readonly', false);
                        // output the request errors to the console
                        console.error(data.Codes, data.ErrorMessages);
                    }
                )
            }
        });
    },

    sendPartnerCode: function () {
        TPS.Register.partnerCode = jQuery(TPS.Register.partnerCodeSelector).val();

        if (typeof TPS.Register.partnerCode != 'undefined' && TPS.Register.partnerCode != '') {
            CMSApp.AV.API.Membership.CheckPartnerCode(TPS.Register.partnerCode, success, fail)
        }

        function success(data) {                        
            if (data) {
                TPS.Register.companyData = data;

                jQuery(TPS.Register.member).hide();
                jQuery(TPS.Register.vpid).hide();
                jQuery(TPS.Register.ssa).hide();
                jQuery(TPS.Register.partnerCompanySelector).val(data.CompanyName);

                data.CompanyName ? document.getElementById('partnerCompany').innerHTML = data.CompanyName : "";
                data.ProgramName ? document.getElementById('companyPlanName').innerHTML = data.ProgramName : "";                                

                if (data.GroupAssociation != '') {
                    jQuery(TPS.Register.labelMemberId).html(data.GroupAssociation);
                    jQuery(TPS.Register.member).show();
                }

                if (data.CompanyTypeID == 2) {
                    jQuery(TPS.Register.vpid).show();
                    jQuery(TPS.Register.ssa).show();
                }

                // if the registrationtype is IDme, then
                // lets add the idme wallet script to the page
                if (data.CompanyRegistrationTypeID === 2) {
                    var _idmeScript = document.getElementById('idmeScript');
                    if (!_idmeScript) {
                        jQuery('body').append('<script id="idmeScript" src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/js/idme-wallet-button.js"></script>');
                    }
                }

                TPS.Register.displayRegisterForm(true);

            } else {
                jQuery(TPS.Register.partnerCompanySelector).val('');
                TPS.Register.displayRegisterForm(false);
            }
        }

        function fail(data) {
            TPS.Register.displayRegisterForm(false);
        }
    },

    displayRegisterForm: function (show) {
        if (show) {
            TPS.Register.CheckEmailDomain();
            TPS.Register.TrimEmailWhiteSpaces();
            TPS.Register.setupFormSections();
        } else {
            jQuery('.registration-partner-company-selected-error').show();
            jQuery('.form-wrapper').hide();
            jQuery('.form-actions').hide();
        }
    },
    
    setupFormSections: function () {               
        jQuery(document).on('click', TPS.Register.btnEditSectionSelector, function (e) {
            e.preventDefault();

            var _atualSection = jQuery(this).closest('.form-wrapper');

            // close all form sections
            jQuery('.form-section-container').each(function () {
                $(this).removeClass('active');
            });

            _atualSection.find(TPS.Register.btnEditSectionSelector).removeClass('active'); // remove edit button on the clicked form section
            _atualSection.find('.form-section-container').addClass('active'); // open clicked form section            
            jQuery('#RegisterCancel, #RegisterSubmit').hide();
        });

        jQuery(document).on('click', TPS.Register.continueSectionSelector, function (e) {
            e.preventDefault()

            var _atualSection = jQuery(this).closest('.form-wrapper');
            var _sectionValid = true;
                                 
            _atualSection.find(':input').each( function () {              
                if (!$(this).valid()) {                                        
                    _sectionValid = false;
                    return false;
                }
            });

            if (_sectionValid) {
                _atualSection.find('.form-section-container').removeClass('active'); // close atual form section
                _atualSection.find(TPS.Register.btnEditSectionSelector).addClass('active'); // show edit button on the atual form section
                _atualSection.next().find('.form-section-container').addClass('active'); // open next form section
                jQuery('#RegisterCancel, #RegisterSubmit').show();
            }
        });        
    },
    
    submitForm: function () {

        var button = jQuery(TPS.Register.formParentSelector).find('.submit-form');

        button.on('click', function (e) {
            e.preventDefault();
            TPS.Forms.resetMessageBlock(TPS.Register.errorBlockSelector);

            if (TPS.Forms.validator.checkForm() && !button.hasClass('submitting')) {
                button.addClass('submitting').append(TPS.Util.submitSpinner);
                var vals = TPS.Forms.getFormVals(TPS.Register.formParentSelector);

                // force stateID from uniselector

                vals['stateID'] = jQuery('#stateID select').val();
                // get the current page culture code from
                // kentico lng hidden input
                var _preferredCulture = jQuery('#lng').val() === 'en-US' ? 'en-US' : vals.rdlLanguage;

                CMSApp.AV.API.Membership.CreateUser(
                    vals.partnerCode,
                    vals.firstname,
                    vals.lastname,
                    vals.address,
                    vals.city,
                    vals.stateID,
                    vals.zipcode,
                    vals.phoneNumber,
                    vals.emailAddress,
                    vals.password,
                    vals.confirmPassword,
                    vals.optIn,
                    vals.preferredContactMethod,
                    vals.memberId,
                    vals.vpid,
                    vals.ssaAccess,
                    _preferredCulture,
                    success,
                    fail
                )
            } else {
                console.log(TPS.Forms.validator.numberOfInvalids() + ' validation errors');
            }
        });

        function success(data) {
            if (data.Success) {
                if (data.RedirectURL) {
                    document.location = data.RedirectURL;
                } else {
                    console.log(data);
                }
            } else {
                TPS.Forms.scrollToMessages(data.ErrorMessages, false, TPS.Register.errorBlockSelector, '.hidden-magellan-error', false);
            }
            button.find('.icon').remove();
            button.removeClass('submitting');
        }

        function fail(data) {
            TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, true, TPS.Register.errorBlockSelector, '.hidden-magellan-error', true);
            button.find('.icon').remove();
            button.removeClass('submitting');
        }
    },

    createEmailDomainMessage: function () {
        var _messageContent;

        _messageContent = '<div class="email-message-wrapper" tabindex="-1" role="alertdialog" aria-labelledby="emailinfo">';
        _messageContent += '<h3>' + window._tps_EmailVerification.message.headline + '</h3>';
        _messageContent += '<p id="emailinfo">' + window._tps_EmailVerification.message.text + '</p>';
        _messageContent += '<div class="email-message-actions">';
        _messageContent += '<div class="email-message-actions-column">';
        _messageContent += '<a href="#" class="button button-link" onclick="TPS.Register.removeFieldMessage(event); return false;">' + window._tps_EmailVerification.message.continueText + '</a>';
        _messageContent += '</div>';
        _messageContent += '</div>';
        _messageContent += '</div>';

        return _messageContent;
    },

    createIDmeMessage: function () {
        var _messageContent;

        _messageContent = '<div class="email-idme-message-wrapper email-message-wrapper" tabindex="-1" role="alertdialog" aria-labelledby="idmeinfo">';
        _messageContent += '<h3>' + window._tps_IDme.message.headline + '</h3>';
        _messageContent += '<p id="idmeinfo">' + window._tps_IDme.message.text + '</p>';
        _messageContent += '<div class="email-message-actions">';
        _messageContent += '<div class="email-message-actions-column">';
        _messageContent += '<span id="idme-wallet-button"';
        _messageContent += 'data-scope="' + window._tps_IDme.scope + '"';
        _messageContent += 'data-client-id="' + window._tps_IDme.clientId + '"';
        _messageContent += 'data-redirect="' + window._tps_IDme.redirect + '"';
        _messageContent += 'data-language="' + TPS.Register.cultureID +'"';
        _messageContent += 'data-response="code"';
        _messageContent += 'data-show-verify="false"';
        _messageContent += 'data-type="popup"';
        _messageContent += 'data-display="popup"></span>';
        _messageContent += '</div>';
        _messageContent += '<div class="email-message-actions-column">';
        _messageContent += '<a href="#" class="button button-link" onclick="TPS.Register.removeFieldMessage(event); return false;">' + window._tps_IDme.message.continueText + '</a>';
        _messageContent += '</div>';
        _messageContent += '</div>';
        _messageContent += '</div>';

        return _messageContent;
    },

    removeFieldMessage: function (e) {
        // remove the idme message
        var _target = jQuery(e.target);
        var _wrapper = _target.parents('.field-message');
        var _input = _wrapper.prev('.email-not-recognized');
        // remove the input style
        _input.removeClass('email-not-recognized').focus();        
        _wrapper.remove();
    }
}
